import request from "@/utils/request";
// 获取消息类型字典项
export function dictData(params) {
    return request({
      url: '/system//dict/data/type',
      method: 'get',
      params
    })
  }






// WEBPACK FOOTER //
// ./src/api/dict.js